import { Link } from 'react-router-dom';
import { Layers, Mail, MapPin, ArrowUpRight } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white border-t-2 border-slate-900" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-[#FF5722] rounded-lg border-2 border-white flex items-center justify-center">
                <Layers className="w-5 h-5 text-white" strokeWidth={3} />
              </div>
              <span className="text-xl font-black tracking-tighter" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
                Slice<span className="text-[#FF5722]">Squads</span>
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm mb-6">
              Turning ideas into real products. From 3D printing to CNC machining, we make custom manufacturing accessible to everyone - beginners, makers, and professionals alike.
            </p>
            <div className="flex items-center gap-2 text-slate-400 text-sm">
              <MapPin className="w-4 h-4" strokeWidth={2.5} />
              <span>SliceSquads.com</span>
            </div>
            <div className="flex items-center gap-2 text-slate-400 text-sm mt-2">
              <Mail className="w-4 h-4" strokeWidth={2.5} />
              <span>hello@slicesquads.com</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-[0.2em] mb-4 text-[#FF5722]">Navigate</h4>
            <ul className="space-y-2">
              {[
                { to: '/', label: 'Home' },
                { to: '/about', label: 'About Us' },
                { to: '/services', label: 'Services' },
                { to: '/contact', label: 'Contact' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-slate-400 hover:text-white text-sm font-medium transition-colors flex items-center gap-1 group" data-testid={`footer-link-${link.label.toLowerCase().replace(' ', '-')}`}>
                    {link.label}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" strokeWidth={2.5} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-[0.2em] mb-4 text-[#6EE7B7]">Services</h4>
            <ul className="space-y-2">
              {['3D Printing', 'CNC Machining', 'Laser Cutting', 'Rapid Prototyping'].map((s) => (
                <li key={s}>
                  <Link to="/services" className="text-slate-400 hover:text-white text-sm font-medium transition-colors" data-testid={`footer-service-${s.toLowerCase().replace(/ /g, '-')}`}>
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-slate-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs">
            &copy; {new Date().getFullYear()} Slice Squads. All rights reserved.
          </p>
          <p className="text-slate-500 text-xs">
            Founded by Ansh & Aayush Shah
          </p>
        </div>
      </div>
    </footer>
  );
}
